import React from "react";
import { Calendar, Clock, ChevronRight, Users } from "lucide-react";
import dayjs from "dayjs";

const EventCardList = ({ filteredEvents, showEventDetails }) => {
  const getEventTypeStyle = (eventType) => {
    let type = eventType;
    if (typeof eventType === "string") {
      try {
        type = JSON.parse(eventType);
      } catch {
        type = eventType;
      }
    }

    const isPublic = type?.label === "Public";
    return {
      wrapper: isPublic
        ? "bg-emerald-50 text-emerald-700"
        : "bg-violet-50 text-violet-700",
      icon: isPublic ? "text-emerald-500" : "text-violet-500",
    };
  };

  return (
    <div className="space-y-4 overflow-auto max-h-[50vh] lg:max-h-[calc(100vh-200px)] px-4">
      {filteredEvents.map((event) => (
        <div
          key={event._id}
          onClick={() => showEventDetails(event)}
          className="relative flex transition-all duration-200 bg-white border border-gray-100 rounded-lg shadow-sm group hover:shadow-md"
        >
          <div className="absolute inset-y-0 left-0 w-1 bg-blue-600 rounded-l-lg" />

          <div className="flex-1 p-4 pl-6">
            {/* Header */}
            <div className="flex items-center justify-between gap-4">
              <div>
                <h4 className="text-lg font-semibold text-gray-900 transition-colors group-hover:text-blue-600">
                  {event?.title}
                </h4>
                <p className="text-sm text-gray-500 mt-0.5">
                  {event?.church_name}
                </p>
              </div>
              <div
                className={`shrink-0 px-2.5 py-1 rounded-full text-xs font-medium ${
                  getEventTypeStyle(event?.event_type).wrapper
                }`}
              >
                <div className="flex items-center gap-1">
                  <Users className="w-3 h-3" />
                  <span>
                    {typeof event?.event_type === "string"
                      ? JSON.parse(event?.event_type)?.label
                      : event?.event_type?.label}
                  </span>
                </div>
              </div>
            </div>

            {/* Time and Date */}
            <div className="flex items-center gap-4 mt-3">
              <div className="flex items-center justify-center text-white bg-blue-600 rounded-lg h-14 w-14 shrink-0">
                <div className="text-center">
                  <div className="text-base font-semibold leading-none">
                    {dayjs(event?.event_start_time, "HH:mm:ss").format("hh:mm")}
                  </div>
                  <div className="mt-1 text-xs">
                    {dayjs(event?.event_start_time, "HH:mm:ss").format("A")}
                  </div>
                </div>
              </div>

              <div className="space-y-1.5">
                <div className="flex items-center gap-1.5 text-gray-600">
                  <Calendar className="w-4 h-4" />
                  <span className="text-sm">
                    {dayjs(event?.event_start_date).format("MMM DD")} -{" "}
                    {dayjs(event?.event_end_date).format("MMM DD")}
                  </span>
                </div>
                <div className="flex items-center gap-1.5 text-gray-600">
                  <Clock className="w-4 h-4" />
                  <span className="text-sm">
                    {dayjs(event?.event_start_time, "HH:mm:ss").format(
                      "hh:mm A"
                    )}{" "}
                    -{" "}
                    {dayjs(event?.event_end_time, "HH:mm:ss").format("hh:mm A")}
                  </span>
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="flex justify-end mt-3">
              <button className="inline-flex items-center gap-1 text-sm font-medium text-blue-600 hover:text-blue-700 group-hover:gap-1.5 transition-all">
                View Details
                <ChevronRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5" />
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default EventCardList;
